class Constants {
  VENDOR_TYPE_VENDOR = 'VENDOR';
  VENDOR_TYPE_MEMBER = 'MEMBER';

}
export default new Constants();
